import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { AutofocusDirective } from './autofocus.directive';
import { TranslationModule } from './models/translation.module';
import { SafePipe } from './safe.pipe';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,

    NgbModule,

    TranslationModule,
  ],
  declarations: [
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    SafePipe,
    AutofocusDirective,
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    SafePipe,
    AutofocusDirective,
    
    TranslationModule,
  ]
})
export class SharedModule {

}